export default "__VITE_ASSET__BFlCdnLk__"